import { render } from "./reset-password.vue?vue&type=template&id=2aa5fbac&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=2aa5fbac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2aa5fbac"

export default script